import { GeoJSON } from "react-leaflet";
import locations from "../locations.json";
import { useEffect, useRef } from "react";
import { capitalizeWord } from "utils/commonUtils";

export default function GeoJSONMap({ selectedLocations, onLocationSelect }) {
  const geo = useRef(null);
  const selectedLocationsRef = useRef(selectedLocations);

  useEffect(() => {
    selectedLocationsRef.current = selectedLocations;
  }, [selectedLocations]);

  const handleFeatureClick = async (e) => {
    e.originalEvent.stopPropagation();
    const layer = e.target;
    const feature = layer.feature;
    onLocationSelect(feature);

    const geometry = feature.geometry;
  };

  const getFeatureStyle = (feature) => {
    const isSelected = selectedLocations.some(
      (loc) => loc.properties.FID_1 === feature.properties.FID_1
    );
    return {
      color: "#0074c1",
      fillColor: "#0074c1",
      fillOpacity: isSelected ? 0.8 : 0.1,
      opacity: 1,
      weight: 2.5,
    };
  };

  const onFeatureMouseOut = (e) => {
    const auxLayer = e.target;
    const feature = e.target.feature;
    auxLayer.closeTooltip();

    const featureId = feature.properties.FID_1;

    if (
      !selectedLocationsRef.current.some(
        (loc) => loc.properties.FID_1 === featureId
      )
    ) {
      auxLayer.setStyle({
        fillOpacity: 0.1,
      });
    }
  };

  const onEachFeature = (feature, layer) => {
    layer.setStyle(getFeatureStyle(feature));
    layer.on({
      mouseover: (e) => {
        const auxLayer = e.target;

        if (
          !selectedLocationsRef.current.some(
            (loc) => loc.properties.FID_1 === feature.properties.FID_1
          )
        ) {
          auxLayer.setStyle({
            fillOpacity: 0.8,
          });
        }
        auxLayer
          .bindTooltip(capitalizeWord(feature.properties.NIL), {
            permanent: true,
            direction: "top",
          })
          .openTooltip();
      },
      mouseout: onFeatureMouseOut,
      click: handleFeatureClick,
    });
  };

  return (
    <GeoJSON
      data={locations.features}
      ref={geo}
      style={getFeatureStyle}
      onEachFeature={onEachFeature}
    />
  );
}
